import { render } from "./AppBreadcrumbs.vue?vue&type=template&id=5d9c170f&scoped=true"
import script from "./AppBreadcrumbs.vue?vue&type=script&lang=js"
export * from "./AppBreadcrumbs.vue?vue&type=script&lang=js"

import "./AppBreadcrumbs.vue?vue&type=style&index=0&id=5d9c170f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d9c170f"]])

export default __exports__